import styled from 'styled-components/macro';

const Score = styled.span`
  font-size: 5rem;
  font-weight: bold;
`;

export default Score;
